import { Uuid } from "@/domains/global/identifiers";
import {
  PreparedRecording,
  PreparedRecordingController,
} from "@/store/audio/recording/prepared-recording-controller/types";
import { DateTime } from "luxon";

export class WebPreparedRecordingController implements PreparedRecordingController {
  prepareRecording({
    customVocabulary,
    audioRecordingId,
  }: {
    customVocabulary: string[] | null;
    audioRecordingId: Uuid;
  }): PreparedRecording {
    return {
      audioRecordingId,
      customVocabulary: customVocabulary,
      windowId: Promise.resolve(""),
      recallUploadCredentials: Promise.resolve({ uploadToken: "", sdkUploadId: null }),
      expiresAt: DateTime.local().plus({ years: 1 }),
      recallStarted: false,
    };
  }
}
